export default "__VITE_ASSET__CK7NMper__"